'use client';

import { c as _c } from "react/compiler-runtime";
import { IconClose } from '@endurancewarranty/icons';
import { cx, DialogOverlay } from '@endurancewarranty/ui';
import { INITIAL_SIDEBAR_DIALOG_STATE, sidebarDialogAtom } from '@lib/states/dialogs/sidebarDialogAtom';
import { useJotaiAtom } from '@states/jotai/hooks';
import type { FC } from 'react';
export const SidebarDialog: FC = () => {
  const $ = _c(15);
  const [sidebarDialogState, setSidebarDialogState] = useJotaiAtom(sidebarDialogAtom);
  const {
    isOpen,
    size: t0,
    children,
    openDirection: t1
  } = sidebarDialogState;
  const size = t0 === undefined ? "sm" : t0;
  const openDirection = t1 === undefined ? "right" : t1;
  const t2 = openDirection === "right";
  const t3 = openDirection === "left";
  const t4 = openDirection === "center";
  let t5;
  if ($[0] !== openDirection || $[1] !== size || $[2] !== t2 || $[3] !== t3 || $[4] !== t4) {
    t5 = cx("h-full absolute", {
      "right-0": t2,
      "left-0": t3,
      "left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2": t4
    }, {
      "w-[1200px]": size === "xl",
      "w-[875px]": size === "lg",
      "w-[700px]": size === "md",
      "w-[525px]": size === "sm"
    }, "pt-24 pb-4", {
      "pr-4": openDirection === "right",
      "pl-4": openDirection === "left"
    });
    $[0] = openDirection;
    $[1] = size;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const containerStyle = t5;
  if (!isOpen) {
    return null;
  }
  let t6;
  if ($[6] !== setSidebarDialogState) {
    t6 = () => setSidebarDialogState(INITIAL_SIDEBAR_DIALOG_STATE);
    $[6] = setSidebarDialogState;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== children || $[9] !== containerStyle || $[10] !== isOpen || $[11] !== sidebarDialogState.hasCloseButton || $[12] !== sidebarDialogState.shouldCloseOnBlur || $[13] !== t6) {
    t7 = <DialogOverlay containerClassName={containerStyle} className="h-full bg-background-0" hasCloseButton={sidebarDialogState.hasCloseButton} renderCloseButton={_temp} isOpen={isOpen} onClose={t6} shouldCloseOnBlur={sidebarDialogState.shouldCloseOnBlur}>{children}</DialogOverlay>;
    $[8] = children;
    $[9] = containerStyle;
    $[10] = isOpen;
    $[11] = sidebarDialogState.hasCloseButton;
    $[12] = sidebarDialogState.shouldCloseOnBlur;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
function _temp(onClose) {
  return <button type="button" aria-label="Close" onClick={onClose} className="absolute right-4 top-4 z-10 flex h-10 w-10 items-center justify-center rounded-full border border-bcolor-active text-text-color-500 hover:border-bcolor-focused"><IconClose width={14} /></button>;
}